import dynamic from 'next/dynamic';
import cn from 'classnames';
import PropTypes from 'prop-types';
import SubMenuItem from 'UI/sections/Header/SubMenuItem';
import { ANIMATED_TYPE } from 'utils/constants';
import { useSmallDropDownMenu } from './utils/useSmallDropDownMenu';
import styles from './styles.module.scss';

const Animated = dynamic(() => import('UI/containers/Animated'));

const SmallDropDownMenu = (props) => {
  const {
    slug,
    selected,
    isPageScrolledDown,
    isDropMenuOpened,
    SubNavigationLinks,
    handleOnLinkClick,
    theme,
    disableAnimation,
  } = useSmallDropDownMenu(props);

  return (
    <div
      className={cn(styles.smallDropDownMenu, {
        [styles.lightTheme]: theme === 'light',
        [styles.pageScrolling]: isPageScrolledDown,
        [styles.closed]: !(selected === slug),
        [styles.noAnimation]: disableAnimation,
      })}
    >
      <div className={cn(styles.container)}>
        <SubNavigationLinks
          isLightTheme={theme === 'light'}
          isPageScrolledDown={isPageScrolledDown}
          handleOnLinkClick={handleOnLinkClick}
        />
        {/* {(subNavigationLinks || []).map(({
          title,
          path,
          marked,
        }) => (
          <Animated
            type={ANIMATED_TYPE.isFade}
            key={path}
            open
          >
            <SubMenuItem
              key={`link/${title}`}
              isLightTheme={isLightTheme}
              isPageScrolledDown={isPageScrolledDown}
              handleOnClick={handleOnLinkClick}
              title={title}
              path={path}
              slug={slug}
              marked={marked}
            />
          </Animated>
        ))} */}
      </div>
    </div>
  );
};

SmallDropDownMenu.propTypes = {
  slug: PropTypes.string.isRequired,
  isLightTheme: PropTypes.bool,
  isPageScrolledDown: PropTypes.bool.isRequired,
  isDropMenuOpened: PropTypes.bool.isRequired,
  closeDropDownMenu: PropTypes.func,
  disableAnimation: PropTypes.bool,
};

export default SmallDropDownMenu;
